<template>
  <div class="DatatrailHome">
    <b-card
      title= "Storage Elements"
      tag="article"
      class="mb-1"
      style="background-color: black; color: white"
    >
      <b-card-text>
        <storage-elements></storage-elements>
      </b-card-text>
    </b-card>
    <b-card
      title= "Datasets & Files"
      tag="article"
      class="mb-1"
      style="background-color: black; color: white"
    >
      <b-card-text>
        <datasets></datasets>
      </b-card-text>
    </b-card>
  </div>
</template>
<script>
import StorageElements from './storage_elements'
import Datasets from './datasets'
// import { AuthVerificationMixin } from '../mixins/auth_mixin.js'
var baseUrl = 'https://frb.chimenet.ca/maestro/datatrail/'
export default {
  // mixins: [AuthVerificationMixin],
  data () {
    return {
      baseUrl: baseUrl,
      plots: {},
      smallTable: true,
      dark: false,
      fixed: true,
      currentPage: 1,
      perPage: 5,
      // totalRows: items.length,
      pageOptions: [ 5, 10, 15, 50, 100 ],
      sortBy: 'id',
      plot: null,
      sortDesc: true,
      sortDirection: 'asc',
      filter: null
    }
  },
  components: {
    'storage-elements': StorageElements,
    'datasets': Datasets
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Datatrail/datatrail_home.vue